import React from 'react';

const WorkflowSection: React.FC = () => {
  return (
    <div className="workflow-section">
      <h3 className="workflow-title">式場様が導入するまでの簡単3ステップ</h3>
      <div className="workflow-steps">
        <div className="workflow-step">
          <div className="step-number">1</div>
          <div className="step-content">
            <h4>お問い合わせ</h4>
            <p>お問い合わせ・担当者とのミーティングを経て最適な運用方法をご提案します</p>
          </div>
        </div>
        <div className="workflow-arrow">→</div>
        <div className="workflow-step">
          <div className="step-number">2</div>
          <div className="step-content">
            <h4>アカウント作成</h4>
            <p>専用URLからアカウントを作成することで<br />アプリの利用ができます</p>
          </div>
        </div>
        <div className="workflow-arrow">→</div>
        <div className="workflow-step">
          <div className="step-number">3</div>
          <div className="step-content">
            <h4>QRコード作成</h4>
            <p>アプリを利用して、<br />QRコード・スクリーンの<br/>準備ができます。</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowSection;
